import React from "react";
import PropTypes from "prop-types";
import Autocomplete from "@mui/material/Autocomplete";
import FormField from "components/MDFormField";
import { Avatar, Box } from "@mui/material";

const MDSelectBox = (props) => {
  return (
    <Autocomplete
      value={props.defaultValue}
      isOptionEqualToValue={(option, value) => option?.label === value?.label}
      options={props.options}
      sx={{ width: props.width ?? 300 }}
      onChange={(event, value) => props.handleChange(value, props.name)}
      multiple={props?.multiple || false}
      renderInput={(params) => (
        <FormField
          {...params}
          onBlur={props?.onBlur}
          label={props.label}
          required={props?.required}
          className="cc-select__box"
        />
      )}
      renderOption={(params, option) => (
        <Box component="li" {...params} sx={{ display: "flex", alignItems: "center" }}>
          {props.isImage && (
            <Avatar
              src={option.imageUrl}
              alt={option.label}
              variant={props.squareImage ? "square" : "circular"}
              sx={{
                width: props.imgWidth ?? 24,
                height: props.imgHeight ?? 24,
                marginRight: 1,
                borderRadius: props.squareImage ? 1 : "50%",
              }}
            />
          )}
          {option.label}
        </Box>
      )}
      disabled={props?.disabled}
    />
  );
};

MDSelectBox.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleChange: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  isImage: PropTypes.bool,
};

export default MDSelectBox;
